module.exports = __webpack_public_path__ + "static/media/vulnerability.3f09af22.svg";